// Close-on-outside-click for the assignee popover (and any other native
// <details> that opts in with data-close-outside). A single delegated
// listener pair covers every current and htmx-swapped-in popover, so it
// wires once and never needs re-init.

let wired = false;

function closeOpen(predicate) {
  document
    .querySelectorAll("details[data-close-outside][open]")
    .forEach((d) => {
      if (predicate(d)) d.open = false;
    });
}

export function initAssigneePopover() {
  if (wired) return;
  wired = true;

  // Click anywhere outside an open popover closes it. Clicks inside
  // (including a member choice, which htmx handles) are left alone.
  document.addEventListener("click", (e) => {
    closeOpen((d) => !d.contains(e.target));
  });

  // Escape closes any open popover. Focus inside one would otherwise
  // drop to the page once its contents hide, so it returns to the
  // popover's own toggle.
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    const holder = document.activeElement?.closest(
      "details[data-close-outside][open]",
    );
    closeOpen(() => true);
    holder?.querySelector("summary")?.focus();
  });
}
